import Delay from './Delay/Delay';
import Schedule from './Schedule/Schedule';
import { types } from './types';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Actions(action,showAlert ,variables, setOpenVariable) {
    if (action.actionName === types.SCHEDULE) {
        return <Schedule action={action} variables={variables} setOpenVariable={setOpenVariable} />;
    }
    else if (action.actionName === types.DELAY) {
        return <Delay action={action} variables={variables} setOpenVariable={setOpenVariable} />;
    }
}

export default Actions;
